<template>
  <form class="login formyukleniyor" @submit.prevent="HesapOlustur">
    <Yukleniyor :data="lo"></Yukleniyor>
    <h4>{{$t('Giris.8')}}</h4>
    <div class="form-group" :class="{ 'is-invalid': hata.isim }">
      <input class="form-control" v-model="user.isim" type="text">
      <label class="form-label">{{$t('Giris.3')}}</label>
      <label class="error" v-if="hata.isim">{{hata.isim}}</label>
    </div>
    <div class="form-group" :class="{ 'is-invalid': hata.email }">
      <input class="form-control" v-model="user.email" type="email">
      <label class="form-label">{{$t('Giris.4')}}</label>
      <label class="error" v-if="hata.email">{{hata.email}}</label>
    </div>
    <div class="form-group" :class="{ 'is-invalid': hata.telefon }">
      <input class="form-control" v-model="user.telefon" type="numbers" maxlength="10">
      <label class="form-label">{{$t('Giris.5')}}</label>
      <label class="error" v-if="hata.telefon">{{hata.telefon}}</label>
    </div>
    <div class="form-group" :class="{ 'is-invalid': hata.parola }">
      <input class="form-control" v-model="user.parola" type="password">
      <label class="form-label">{{$t('Giris.6')}}</label>
      <label class="error" v-if="hata.parola">{{hata.parola}}</label>
    </div>
    <div class="form-group" :class="{ 'is-invalid': hata.sozlesme }">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="user.sozlesme" id="defaultCheck1">
        <label class="form-check-label " for="defaultCheck1">
          <small><a href="https://www.aidatim.net/hizmet-sozlesmesi" target="_blank"> {{$t('Giris.12')}}</a>
          </small>
        </label>
      </div>
      <label class="error" v-if="hata.sozlesme">{{hata.sozlesme}}</label>
    </div>
    <div class="form-group">
      <router-link to="/giris" class="hesap text-mavi float-left">{{$t('Giris.2')}}</router-link>
      <button type="submit" class="btn btn-yesil float-right">
        {{$t('Giris.11')}}
      </button>
    </div>
    <div class="clearfix"></div>
    <hr>
    <small class="text-yesil"><i class="flaticon2-protected"></i><span v-html="$t('Giris.17')"></span>
    </small>
  </form>
</template>

<script>

  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        user: {
          isim: null,
          email: null,
          telefon: null,
          parola: null,
          sozlesme: null,

        },
        hata: {
          isim: null,
          email: null,
          telefon: null,
          parola: null,
          sozlesme: null,
        },
      }
    },
    methods: {
      HesapOlustur() {

        if (!this.user.isim) this.hata.isim = this.$t('Hata.0'); else this.hata.isim = null;
        if (!this.user.email) this.hata.email = this.$t('Hata.1'); else this.hata.email = null;
        if (!this.user.telefon) this.hata.telefon = this.$t('Hata.3'); else this.hata.telefon = null;
        if (!this.user.parola) this.hata.parola = this.$t('Hata.2'); else this.hata.parola = null;
        if (!this.user.sozlesme) this.hata.sozlesme = this.$t('Hata.5'); else this.hata.sozlesme = null;
        if (this.user.telefon) {
          var alankodu = this.user.telefon[0] + this.user.telefon[1];
          if (alankodu != '50' && alankodu != '53' && alankodu != '54' && alankodu != '55' && alankodu != '56') this.hata.telefon = this.$t('Hata.6'); else this.hata.telefon = null;
        }
        if (!this.hata.isim && !this.hata.email && !this.hata.telefon && !this.hata.sozlesme) {
          $(".login").addClass("load");
          this.$store.dispatch("Login", {...this.user, path: 'giris/hesap'})
            .then(response => {
              if (response.Durum == "OK") {
                this.$message(response.Mesaj);
                this.$router.push('/giris/onay');
                $(".login").removeClass("load");
              } else {
                this.hata = response.Hata;
                this.$message.error(response.Mesaj);
                $(".login").removeClass("load");
              }
            })
        }
      },
    },
    computed: {
      telefonIzle() {
        return this.user.telefon;
      }
    },
    watch: {
      telefonIzle() {
        var alankodu = this.user.telefon[0] + this.user.telefon[1];
        if (alankodu != '50' && alankodu != '53' && alankodu != '54' && alankodu != '55' && alankodu != '56' && this.user.telefon[2] != '_' && this.user.telefon[2]) this.hata.telefon = this.$t('Hata.6'); else this.hata.telefon = null;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Giris/hesap.vue